<template>
  <v-row>
    <v-col
      cols="12"
      md="8"
    >
      <v-card outlined>
        <v-card-text>
          <div>Information</div>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="form.fullName"
                hide-details="auto"
                label="Customer Full Name"
                outlined
                dense
                :error-messages="errors.getMessage('fullName')"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="form.phone"
                hide-details="auto"
                label="Customer Phone"
                outlined
                dense
                :error-messages="errors.getMessage('phone')"
              />
            </v-col>
            <v-col
              cols="12"
              md="12"
            >
              <v-textarea
                v-model="form.address"
                hide-details="auto"
                label="Full Address"
                outlined
                dense
                rows="2"
                :error-messages="errors.getMessage('address')"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="form.model"
                hide-details="auto"
                label="Device Model"
                outlined
                dense
                :error-messages="errors.getMessage('model')"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="form.imei"
                hide-details="auto"
                label="IMEI Number"
                outlined
                dense
                :error-messages="errors.getMessage('imei')"
              />
            </v-col>
          </v-row>
          <VueSignaturePad
            id="signature"
            ref="signaturePad"
            :class="padShow ? 'error--text' : 'info--text'"
          />
          <v-spacer />
          <template v-if="padShow">
            <v-btn
              class="error"
              small
              @click="undo"
            >
              Clear
            </v-btn>
            <v-btn
              class="success"
              small
              @click="save"
            >
              Save
            </v-btn>
          </template>
          <template v-else>
            <v-btn
              class="info"
              small
              @click="activeSignPad"
            >
              Activate
            </v-btn>
          </template>
        </v-card-text>

        <v-card-text>
          <v-expansion-panels focusable>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Upload Photo
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <photo-cam
                  :event-name="'eventPhoto'"
                  :value="form.photo"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Upload Identity
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <photo-cam
                  :event-name="'eventDocs'"
                  :value="form.docs"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      md="4"
    >
      <v-card outlined>
        <v-card-text>
          <div>Properties</div>
          <v-col cols="12">
            <v-text-field
              v-model="form.cost"
              hide-details="auto"
              label="Cost (Buyying Price)"
              outlined
              dense
              type="number"
              :error-messages="errors.getMessage('cost')"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="form.price"
              hide-details="auto"
              label="Price (Selling Price)"
              outlined
              dense
              type="number"
              :error-messages="errors.getMessage('price')"
            />
          </v-col>
        </v-card-text>
      </v-card>
      <div class="text-center">
        <v-btn
          color="green"
          class="ma-2 white--text"
          @click="submitForm"
        >
          Save
          <v-icon
            right
            dark
          >
            mdi-plus
          </v-icon>
        </v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Camera from "../common/WebCam.vue";
export default {
  components: {
    "photo-cam": Camera,
  },
  data() {
    return {
      padShow: false,
      isEditing: false,
      options: {
        penColor: "#000000",
      },
      form: {
        sign: null,
        photo: null,
        docs: null,
        fullName: "",
        phone: "",
        address: "",
        model: "",
        imei: "",
        cost: "",
        price: "",
      },
    };
  },
  created() {
    Event.$on("eventPhoto", (link) => {
      this.$data.form.photo = link;
    });
    Event.$on("eventDocs", (link) => {
      this.$data.form.docs = link;
    });
  },
  computed: {
    ...mapGetters({
      errors: "validation/pull",
    }),
  },
  mounted() {
    if (this.$route.params.id) {
      window.axios
        .get("/custom-product/" + this.$route.params.id)
        .then((response) => {
          this.$data.form = response.data.item;
          this.$data.isEditing = true;
          this.$refs.signaturePad.fromDataURL(this.$data.form.sign);
        });
    }
    this.$refs.signaturePad.lockSignaturePad();
  },
  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),
    activeSignPad() {
      this.padShow = true;
      this.$nextTick(() => {
        this.$refs.signaturePad.openSignaturePad();
        this.$refs.signaturePad.resizeCanvas();
      });
    },
    undo() {
      this.$refs.signaturePad.clearSignature();
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      this.form.sign = data;
      this.$refs.signaturePad.lockSignaturePad();
      this.padShow = false;
    },
    submitForm() {
      if (this.$data.isEditing) {
        this.updateItem();
      } else {
        this.createItem();
      }
    },

    formHandle() {
      const form = this.$data.form;
      const formData = new FormData();
      formData.append("fullName", form.fullName);
      formData.append("phone", form.phone);
      formData.append("address", form.address);
      formData.append("model", form.model);
      formData.append("imei", form.imei);
      formData.append("cost", form.cost);
      formData.append("price", form.price);
      formData.append("sign", form.sign);
      if (form.photo && form.photo instanceof Blob) {
        formData.append("photo", form.photo, form.photo.name);
      }
      if (form.docs && form.docs instanceof Blob) {
        formData.append("docs", form.docs, form.docs.name);
      }
      return formData;
    },
    updateItem() {
      window.axios
        .post(
          "/custom-product-update/" + this.$route.params.id,
          this.formHandle()
        )
        .then((response) => {
          this.$data.form = {};
          this.feedback(response.data.message);
          this.$router.push({ name: "CustomProductList" });
        });
    },
    createItem() {
      window.axios
        .post("/custom-product", this.formHandle())
        .then((response) => {
          this.$data.form = {};
          this.feedback(response.data.message);
          this.$router.push({
            name: "CustomBuyPrint",
            params: { id: response.data.item.id },
          });
        });
    },
  },
};
</script>
<style type="text/css">
.sign {
  padding: 2%;
  padding-top: 5%;
  width: 90%;
  height: 90%;
}

#signature {
  border: 2px dashed;
  border-radius: 2px;
  margin-bottom: 5px;
}
</style>
